import React from "react";

const HistoryContainer = () => {
  return (
    <>
      <div className="flex flex-col gap-5 w-[694px] px-2">
        <div className="flex flex-col gap-4">
          <h1 className="text-[28px] font-semibold border-b-[1px] border-gray-400">
            History
          </h1>
          <p className="text-[15px] font-medium">
            {" "}
            The Council for Secondary and Senior Secondary Education was
            registered. To provide professional services to the government and
            other agencies in the field of education, in general, and school
            education, in particular, for the development and growth of distance
            and open school system and develop appropriate curriculum for
            vocational and continuing education to prepare student population
            for the world of work. To establish linkages with traditional
            education systems like State Open Schools, Sanskrit Boards and
            Madarsas with mainstream education system with mobility across them
            and equivalence between them, the CSSE wishes to work in close
            collaboration with the Open Schools, State Open Schools, Sanskrit
            Boards and Madarsas. In this regard, CSSE will also follow the norms
            for conducting examinations as also follow National Curriculum
            Framework, 2005, as amended from time to time. Council for Secondary
            and Senior Secondary Education was envisaged as a comprehensive
            instructional delivery institution that offered the liberty to
            students to get education without the bottleneck of attending daily
            classes. We have succeeded in creating a distance education program
            as a planned extended learning endeavour. CSSE has gained an
            expertise in delivering instructional resources and thereby
            providing opportunities to students located away from the
            organization. We have expanded our distance education program in
            India.With comprehensive online solutions for the students, our
            motto is to help everyone in need of quality education in all
            corners of the world. The remarkable contribution of CSSE in the
            field of education has been to achieve Discipline andquality of
            education which is the backbone of CSSE. The Nationality policy on
            Education suggested strengthening of CSSE for extending open
            learning facilities in a phased manner at High School&Intermediate
            levels all over the country and abroad as an independent system with
            its own curriculum and examination leading to awarding of
            certificates. What makes CSSE a convenient and viable approach
            towards education is that students get the facility of online
            admission and their enrollment number is given right way. Moreover,
            the online study material is provided in different languages as per
            the subjects opted by the students or their preference. We also
            provide online verification of the results of the pass out students.
            Our vision of providing education to school students in India and
            students or working professional abroad has taken shape by way of
            the expansion of instructional delivery facilities In India and
            abroad. These educational facilities are intended to target specific
            needs of students all over the world.
          </p>
        </div>
      </div>
    </>
  );
};

export default HistoryContainer;
